<!-- eslint-disable vue/no-mutating-props -->
<template>
  <card :title="computedTitle" :on-cancel="cancel">
    <Form ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(saveToolType)">
        <div class="row">
          <div class="col-md-4">
            <material-input-field
              id="toolTypeInput"
              ref="toolTypeInput"
              v-model="toolType"
              :name="'toolType'"
              variant="static"
              :label="$t('toolTypes.toolType') + ' *'"
              :placeholder="$t('toolTypes.toolType')"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-sm d-flex justify-content-end">
            <material-button variant="gradient" color="dark" @click="saveToolType">
              {{$t('common.submit')}}
            </material-button>
          </div>
        </div>
      </form>
    </Form>
  </card>
</template>
<script>
import api from "../../services/api"
import { getApiErrorMessage } from "../../utils/apiError";
import { Form } from 'vee-validate';
import Card from "../../components/Card.vue";
import MaterialInputField from "@/components/MaterialInputField.vue";
import MaterialButton from "@/components/MaterialButton.vue";

export default {
  components: {
    Form,
    Card,
    MaterialInputField,
    MaterialButton
  },
  props: {
    editMode: {
      type: Boolean,
      required: true
    },
    toolTypeProp: {
      type: String,
      required: false,
      default: ''
    },
    toolTypeId: {
      type: Number,
      required: false,
      default: null
    }
  },
  emits: ['close', 'refresh-data'],
  data() {
    return {
      isMobile: window.innerWidth <= 1024,
      toolType: this.toolTypeProp,
    };
  },
  computed: {
    computedTitle() {
      return this.editMode ? this.$t('toolTypes.editToolType') : this.$t('toolTypes.createToolType');
    },
  },
  created() {
    window.addEventListener('resize', this.updateIsMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateIsMobile);
  },
  methods: {
    updateIsMobile() {
      this.isMobile = window.innerWidth <= 1024;
    },
    cancel()
    {
      this.$emit('close');
    },
    async saveToolType() {
      if (this.validateInput()) {
        if (this.editMode) {
          await api.put('/ToolType/' + this.toolTypeId, { type: this.toolType }).then(() => {
            this.$toast.success(this.$t('toolTypes.toolTypeUpdated'), { timeout: 1500 });

            this.$emit('refresh-data');
            this.$emit('close');
          }).catch(error => {
            console.error(error) // eslint-disable-line no-console
            this.$toast.danger(getApiErrorMessage(this.$t, error), { timeout: 0 });
          });
        }
        else {
          await api.post('/ToolType', { type: this.toolType }).then(() => {
            this.$toast.success(this.$t('toolTypes.toolTypeCreated'), { timeout: 1500 });

            this.$emit('refresh-data');
            this.$emit('close');
          }).catch(error => {
            console.error(error) // eslint-disable-line no-console
            this.$toast.danger(getApiErrorMessage(this.$t, error), { timeout: 0 });
          });
        }
      }
    },
    validateInput() {
      let success = true;
      if (this.toolType === '') {
        this.$toast.info(this.$t('errors.newToolTypeEmpty'), { timeout: 2500 });
        success = false;
      }
      
      return success;
    }
  }
};
</script>
<style></style>
